// Config for object layers in the world

export interface ObjectLayerConfig {
  // Asset path relative to the public folder
  assetPath: string;
  // Position coordinates
  x: number;
  y: number;
  // Layer order (higher numbers appear on top)
  zIndex: number;
  // Scale factor
  scale?: number;
  // Unique identifier for the layer
  id: string;
  // Whether this layer should be loaded automatically
  autoLoad?: boolean;
}

export const objectLayersConfig: ObjectLayerConfig[] = [
  // {
  //   id: 'rumah1',
  //   assetPath: '/assets/background/rumah1-half.png',
  //   x: 1738,
  //   y: 1310,
  //   zIndex: 5,
  //   scale: 0.29,
  //   autoLoad: true
  // },

  {
    id: 'allOverlay',
    assetPath: '/assets/background/overlay.png',
    x: 0,
    y: 0,
    zIndex: 5,
    scale: 1.2,
    autoLoad: true
  },

  // Add more object layers as needed
  // Example:
  // {
  //   id: 'tree1',
  //   assetPath: '/assets/background/tree1.png',
  //   x: 800,
  //   y: 400,
  //   zIndex: 3,
  //   scale: 0.8,
  //   autoLoad: true
  // }
];
